import React from 'react';
import {PhotoUploader} from '../PhotoUploader';
import {zoneLabel,typeLabel} from '../../lib/vehicleDamage';

export default function DamageEvidence({items=[],title}) {
  return <section className="space-y-3" aria-label={title}><h3 className="text-lg font-semibold">{title} · {items.length}</h3>
    {!items.length&&<p className="text-sm text-muted-foreground">Nessun rilievo registrato in questo verbale.</p>}
    {items.map((item,index)=><article key={item.id} className="space-y-3 rounded-lg border border-border p-4" aria-label={`${title}, danno ${index+1}`}>
      <h4 className="font-semibold">{index+1}. {zoneLabel(item.zone)} · {typeLabel(item.type)}</h4>
      <p className="whitespace-pre-wrap break-words">{item.description}</p>
      <PhotoUploader readOnly value={item.photos} label={`Foto del danno ${index+1}`}/>
    </article>)}
  </section>;
}
